import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import { Person as MasterIcon } from '@material-ui/icons';

class DetailPanelUsers extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        userMasterId: PropTypes.number.isRequired,
        usersList: PropTypes.object.isRequired
    };

    render() {
        const { usersList, userMasterId, onClick, classes, match } = this.props;
        return (
            <div className={classes.detailPanelContainer}>
                <div className={`${classes.detailPanelTableRow} ${classes.detailPanelHeader}`}>
                    <div className={classes.detailPanelText}>{Translator.translate('general.table.column.owner')}</div>
                    <div className={classes.detailPanelText}>{Translator.translate('general.table.column.email')}</div>
                    <div className={classes.detailPanelText}>{Translator.translate('general.table.column.firstname')}</div>
                    <div className={classes.detailPanelText}>{Translator.translate('general.table.column.lastname')}</div>
                </div>
                {usersList.map(user => {
                    const isMaster = user.get('_id') === userMasterId;
                    return (
                        <div
                            className={`${classes.detailPanelTableRow} ${isMaster ? classes.masterRow : classes.userRow}`}
                            onClick={parseInt(match.params.userId) !== user.get('_id') ? onClick : null}
                            data-userid={user.get('_id')}
                            role="presentation"
                            key={user.get('email')}
                        >
                            <div className={classes.detailPanelText}>{isMaster && <MasterIcon />}</div>
                            <div className={classes.detailPanelText}>{user.get('email')}</div>
                            <div className={classes.detailPanelText}>{user.get('firstname')}</div>
                            <div className={classes.detailPanelText}>{user.get('lastname')}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const styles = theme => ({
    detailPanelContainer: {
        minHeight: 50
    },
    detailPanelTableRow: {
        backgroundColor: '#eeeeee',
        borderBottom: '1px solid #f2f2f2',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        width: '100%',
        paddingLeft: 15,
        paddingRight: 15,
        height: 30,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    },
    detailPanelHeader: {
        color: theme.palette.text.secondary,
        borderBottom: '1px solid #bcbcbc',
        paddingTop: 8,
        paddingBottom: 8
    },
    detailPanelText: {
        padding: '0 15px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        width: 0,
        flexGrow: 1,
        '-webkit-flex-grow': 1,
        '@media screen and (max-width: 599px)': {
            paddingLeft: 15,
            width: 180
        }
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    }
});

export default withRouter(withStyles(styles, { withTheme: true })(DetailPanelUsers));



// WEBPACK FOOTER //
// ./data/components/DetailPanelUsers.js